<div class="timesheet-row" [class.timesheet-row--locked]="row().inProgress">
    <div class="timesheet-row__times">
        <pace-instant-field
            [formField]="entry().start"
            [minInstant]="minInstant()"
            [dateAriaLabel]="'TIMESHEET_START_DATE_LABEL_NOTIFICATION' | translate"
            [timeAriaLabel]="'TIMESHEET_START_TIME_LABEL_NOTIFICATION' | translate"
        ></pace-instant-field>
        <pace-instant-field
            class="d-block mt-2"
            [formField]="entry().end"
            [maxInstant]="maxInstant()"
            [dateAriaLabel]="'TIMESHEET_END_DATE_LABEL_NOTIFICATION' | translate"
            [timeAriaLabel]="'TIMESHEET_END_TIME_LABEL_NOTIFICATION' | translate"
        ></pace-instant-field>
    </div>

    <div class="timesheet-row__duration">{{ duration() }}</div>

    <div class="timesheet-row__activity">
        <!--
            An unlocked travel-back leg is the one work entry whose kind the technician may change:
            billable or standby, and by which transport. Everything else states what it is.
        -->
        @if (canEditTravelType()) {
            <pace-select-field
                [formField]="entry().workCode"
                [options]="travelTypeOptions()"
                [ariaLabel]="'TIMESHEET_TABLE_ACTIVITY_LABEL' | translate"
            ></pace-select-field>
        } @else {
            <span [title]="row().workCode">{{ workCodeDescription() }}</span>
            @if (meansOfTransportText()) {
                <span> | {{ meansOfTransportText() }}</span>
            }
        }

        @if (canEditMeansOfTransport()) {
            <pace-select-field
                class="d-block mt-2"
                [formField]="entry().meansOfTransport"
                [options]="meansOfTransportOptions()"
                [ariaLabel]="'TIMESHEET_MEANS_OF_TRANSPORT_LABEL' | translate"
            ></pace-select-field>
        }

        @if (row().inProgress) {
            <span class="badge text-bg-secondary ms-2" translate="TIMESHEET_IN_PROGRESS_LABEL"></span>
        }
    </div>

    <div class="timesheet-row__meta">
        <!-- The way to the confirmation while it is still open, since that is where these times are corrected. -->
        @if (confirmationLink().length) {
            <div>
                <a
                    [routerLink]="confirmationLink()"
                    [attr.aria-label]="
                        'TIMESHEET_OPEN_CONFIRMATION_LABEL' | translate: { notification: row().notificationId.qmNum }
                    "
                    >{{ notificationDescription() }}
                    @if (isShortConfirmation()) {
                        <br />
                        {{ 'NOTIFICATION_DETAILS_SHORT_CONFIRMATION_TITLE' | translate }}
                    }
                </a>
            </div>
        } @else {
            <div>
                {{ notificationDescription() }}
                @if (isShortConfirmation()) {
                    <br />
                    {{ 'NOTIFICATION_DETAILS_SHORT_CONFIRMATION_TITLE' | translate }}
                }
            </div>
        }
        @if (customerAndCity()) {
            <small class="text-muted">{{ customerAndCity() }}</small>
        }
    </div>

    <div class="timesheet-row__actions"></div>
</div>
